import { render, staticRenderFns } from "./position_details.vue?vue&type=template&id=4359c916&scoped=true"
import script from "./position_details.vue?vue&type=script&lang=js"
export * from "./position_details.vue?vue&type=script&lang=js"
import style0 from "./position_details.vue?vue&type=style&index=0&id=4359c916&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4359c916",
  null
  
)

export default component.exports